import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import Link from '../../../../global/Link'
import { OrderInvoiceEntryData } from './types'

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;

  ${SecondaryButton} {
    width: 76px;
    margin-left: 16px;
    @media print {
      display: none;
    }
  }
`

export interface OrderInvoiceEntryProps {
  className?: string
  invoice: OrderInvoiceEntryData
}

const OrderInvoiceEntry: React.FC<OrderInvoiceEntryProps> = ({ className, invoice }) => {
  return (
    <div className={className}>
      <StyledContainer>
        <div>Invoice #{invoice.transactionNumber}</div>
        <StyledButtonContainer>
          <SecondaryButton
            as={Link}
            to={`/account/transactions/invoices/${invoice.transactionNumber}`}
          >
            View
          </SecondaryButton>
          <SecondaryButton
            as={Link}
            to={`/account/transactions/invoices/${invoice.transactionNumber}?print=true`}
            target="_blank"
          >
            Print
          </SecondaryButton>
        </StyledButtonContainer>
      </StyledContainer>
    </div>
  )
}

const StyledOrderInvoiceEntry = styled(OrderInvoiceEntry)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  overflow: hidden;
`

export { StyledOrderInvoiceEntry as OrderInvoiceEntry }
